import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { MapPin } from 'lucide-react';
import { PRIORIDADES } from '@/utils/tareaUtils';

export default function VistaLote({ tareas, lotes }) {
  const lotesConTareas = lotes.filter(l => 
    tareas.some(tarea => tarea.lote_id === l.id)
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {lotesConTareas.map(lote => {
        const tareasLote = tareas.filter(t => t.lote_id === lote.id);
        return (
          <Card key={lote.id}>
            <CardHeader>
              <CardTitle className="text-lg flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                {lote.nombre}
                <Badge className="ml-2">{tareasLote.length}</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {tareasLote.map(tarea => (
                <div key={tarea.id} className="mb-2 p-3 bg-gray-50 rounded hover:bg-gray-100 cursor-pointer transition">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-semibold text-sm">{tarea.titulo}</h4>
                      <p className="text-xs text-gray-600">{tarea.responsable_nombre || 'Sin asignar'}</p>
                    </div>
                    <Badge className={PRIORIDADES[tarea.prioridad].color} size="sm">
                      {PRIORIDADES[tarea.prioridad].icon}
                    </Badge>
                  </div>
                </div>
              ))}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
